<template>
	<div class="print-solicitacao" v-if="exibir">
		<div class="row print">
			<flCabecalho widthimg="130" top="16" />
		</div>

		<div class="table-responsive" style="margin-top: 8px">
			<table style="width: 100%">
				<tr>
					<td>
						<table class="table table-bordered table-condensed table-siga">
							<thead>
								<tr>
									<th colspan="7" style="background: #eee" class="text-center">
										{{ form.numero }} -  {{ _traducao('global', 'programacaoVoo') }} 
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<strong
											>{{ _traducao('global', 'numeroDaProgramacao') }}:</strong
										><br />
										{{ form.numero }}
									</td>
									<td>
										<strong>{{ _traducao('global', 'status') }}:</strong><br />
										<span v-if="form.status == 'E'">{{
											_traducao('global', 'encerrada').toUpperCase()
										}}</span>
										<span v-if="form.status == 'A'">{{
											_traducao('global', 'aberta').toUpperCase()
										}}</span>
									</td>
									<td>
										<strong>
											{{ _traducao('global', 'inicio')}}
											<small>(UTC{{ _fusoHorario }})</small>
										:</strong
										><br />
										{{ form.data_inicio }}
									</td>
								</tr>
								<tr>
									<td>
										<strong>{{ _traducao('global', 'base') }}:</strong><br />
										<strong>{{ _traducao('global', 'aeronave') }}:</strong
										><br />
										<strong>{{ _traducao('global', 'tripulacao') }}:</strong>
									</td>
									<td colspan="6">
										<div v-for="(a, i) in aeronaves" :key="i">
											<span v-if="a.id == form.aeronave.id_aeronave">
												<span v-for="b in bases" :key="b.descricao"
													><span v-if="b.id == form.aeronave.base">{{
														b.descricao
													}}</span></span
												><br />
												{{ a.codinome }} - {{ a.prefixo }}
												<span
													v-for="(it, idxTrip) in form.aeronave.tripulacao"
													:key="it.trigrama"
													><br />
													<span
														v-if="
															form.aeronave.voo_instrucao == '1' && idxTrip == 0
														"
													>
														{{
															_traducao('global', 'instrutorVoo').toUpperCase()
														}}
													</span>
													<span v-else>
														{{ it.funcao.toUpperCase() }}
													</span>
													<i
														class="fa fa-fw fa-long-arrow-right"
														aria-hidden="true"
													></i
													>{{ it.usuarios.nome }}</span
												>
											</span>
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<strong
											>{{ _traducao('global', 'identificacaoVoo') }}:</strong
										>
									</td>
									<td colspan="6" v-if="form.numero_voo">
										{{ form.numero_voo }}
									</td>
								</tr>
								<tr>
									<td>
										<strong>{{ _traducao('global', 'trechos') }}:</strong>
									</td>
									<td colspan="6">
										<p
											v-for="(trecho, index) in form.aeronave.trecho"
											:key="index"
										>
											{{ trecho.designativo_partida.sigla }}
											<i class="fa fa-arrow-right"></i>
											{{ trecho.designativo_destino.sigla || 'ZZZZ' }}
										</p>
									</td>
								</tr>

								<tr v-if="form.aeronave.passageiro.length > 0">
									<td>
										<strong v-if="tripulacaoTecnica == '1'"
											>{{ _traducao('global', 'tripulacaoTecnica') }}:</strong
										>
										<strong v-else
											>{{ _traducao('global', 'passageiros') }}:</strong
										>
									</td>
									<td colspan="6">
										<div
											v-for="(passeiro, index) in form.aeronave.passageiro"
											:key="index"
										>
											<span>
												<b>{{ _traducao('global', 'nome') }}:</b>
												{{ passeiro.nome }} - <b> {{retornaTitulo(passeiro)}} </b>
												{{retornaDados(passeiro)}}
											</span>
										</div>
									</td>
								</tr>
							</tbody>
						</table>

						<table
							v-if="form.id_ordem_missao != null"
							class="table table-bordered table-condensed table-siga"
							style="margin-top: 8px"
						>
							<thead>
								<tr>
									<th colspan="3" style="background: #eee" class="text-center">
										{{ form.ordem_codigo }} -
										{{
											_traducao(
												'menuOrdemMissao',
												'menuOrdemmissao'
											).toUpperCase()
										}}
									</th>
								</tr>
								<tr>
									<th>{{ _traducao('global', 'codigo') }}</th>
									<th>{{ _traducao('global', 'dataInicio') }}</th>
									<th>{{ _traducao('global', 'descricao') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										{{ form.ordem_codigo }}
									</td>
									<td>
										{{ form.ordem_data_inicio | dataTempo }}
									</td>
									<td>
										{{ form.ordem_descricao }}
									</td>
								</tr>
							</tbody>
						</table>

						<table
							v-if="form.id_solicitacao != null && form.id_solicitacao != ''"
							class="table table-bordered table-condensed table-siga"
							style="margin-top: 8px"
						>
							<thead>
								<tr>
									<th colspan="3" style="background: #eee" class="text-center">
										{{ form.solicitacao_codigo }} - SOLICITAÇÃO DE USO DE
										AERONAVE
									</th>
								</tr>
								<tr>
									<th>{{ _traducao('global', 'descricao') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										{{ form.solicitacao_descricao }}
									</td>
								</tr>
							</tbody>
						</table>

						<table
							v-if="form.codigo_prevencao"
							class="table table-bordered table-condensed table-siga"
							style="margin-top: 8px"
						>
							<thead>
								<tr>
									<th colspan="4" style="background: #eee" class="text-center">
										{{ form.codigo_prevencao }} -
										{{
											_traducao(
												'global',
												'ordemMissaoPrevencaoQualificada'
											).toUpperCase()
										}}
									</th>
								</tr>
								<tr>
									<th>{{ _traducao('global', 'codigo') }}:</th>
									<th>{{ _traducao('global', 'dataInicio') }}:</th>
									<th>{{ _traducao('global', 'dataFim') }}:</th>
									<th>{{ _traducao('global', 'descricao') }}:</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										{{ form.codigo_prevencao }}
									</td>
									<td>
										{{ form.inicio_prevencao | dataTempo }}
									</td>
									<td>
										{{ form.fim_prevencao | dataTempo }}
									</td>
									<td>
										{{ form.descricao_prevencao }}
									</td>
								</tr>
							</tbody>
						</table>
						<pre style="display: none">{{ form }}</pre>
						<flDiarioResumido ref="relatorioVoo"></flDiarioResumido>
					</td>
				</tr>
			</table>
		</div>
		<!-- roteiro -->
		<div>
			<table class="table table-bordered table-condensed table-siga">
				<thead>
					<tr>
						<th colspan="40" style="background: #f9f9f9" class="text-center">
							{{ _traducao('global', 'roteiro').toUpperCase() }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<strong>Nº</strong>
						</td>
						<td>
							<strong>{{ _traducao('menuSolicitaApoio', 'partida') }}</strong>
						</td>
						<td>
							<strong>{{ _traducao('global', 'decolagem') }}
								<small v-if="trechoSolicitacao == 'basico'"><span>(UTC{{ _fusoHorario }})</span></small>
								<small v-else-if="trechoSolicitacao == 'avancado' && fusoHorario == 'sistema'"><span>(UTC{{ _fusoHorario }})</span></small>
								<small v-else><span>(LOCAL)</span></small>
							</strong
							>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'nascer') }}</strong>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'por') }}</strong>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'proa') }}</strong>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'distancia') }}</strong>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'tempoEstimado') }}</strong>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'combustivel') }}</strong>
						</td>
						<td>
							<strong>{{ _traducao('menuSolicitaApoio', 'destino') }}</strong>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'pouso') }}
								<small v-if="trechoSolicitacao == 'basico'"><span>(UTC{{ _fusoHorario }})</span></small>
								<small v-else-if="trechoSolicitacao == 'avancado' && fusoHorario == 'sistema'"><span>(UTC{{ _fusoHorario }})</span></small>
								<small v-else><span>(LOCAL)</span></small>
							</strong>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'nascer') }}</strong>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'por') }}</strong>
						</td>
						<td class="text-center">
							<strong>{{ _traducao('global', 'autonomia') }}</strong>
						</td>
					</tr>
					<tr v-for="(itemRot, idxRot) in form.aeronave.roteiro" :key="idxRot">
						<td>
							{{ idxRot + 1 }}
						</td>
						<td>
							{{ itemRot.cidade_partida }} /
							{{ itemRot.designativo_partida }}
							<span v-if="itemRot.descricao_partida != ''">
								{{ itemRot.descricao_partida }}</span
							>
						</td>
						<td  class="text-center">
							{{ `${itemRot.decolagem_data} ${itemRot.decolagem_hora}` }}
						</td>
						<td class="text-center">
							{{ itemRot.nascer_partida | apPmTo24 }}
						</td>
						<td class="text-center">
							{{ itemRot.por_partida | apPmTo24 }}
						</td>
						<td class="text-center">{{ itemRot.proa | arredondar2 }}°</td>
						<td class="text-center">
							{{ itemRot.distancia | adicionaMN }}
						</td>
						<td class="text-center">
							{{ itemRot.tempo | decimalEmTempo2 }}
						</td>

						<td class="text-center">{{ itemRot.combustivel }}{{ itemRot.combustivel != null ? 'L' : 'N/A' }}</td>
						<td>
							{{ itemRot.cidade_destino }} /
							{{ itemRot.designativo_destino }}
							<span v-if="itemRot.descricao_destino != ''">
								{{ itemRot.descricao_destino }}</span
							>
							<!--   <p><small>{{itemRot.estado_destino.toUpperCase()}}</small> <br/>
			{{itemRot.cidade_destino}}<i class="fa fa-fw fa-angle-right" aria-hidden="true"></i><small>{{itemRot.designativo_destino}}</small>
			<span v-if="itemRot.descricao_destino != ''"> ({{itemRot.descricao_destino}})</span></p> -->
						</td>
						<td class="text-center">
							{{ itemRot.pouso_data }}
							{{ itemRot.pouso_hora }}
						</td>
						<td class="text-center">
							{{ itemRot.nascer_destino | apPmTo24 }}
						</td>
						<td class="text-center">
							{{ itemRot.por_destino | apPmTo24 }}
						</td>

						<td class="text-center">
							{{ itemRot.autonomia }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<flGeradoPor />
	</div>
</template>

<script>
import flDiarioResumido from '../diario-de-bordo-piloto/mg-siga/print/resumo.vue'

export default {
	components: {
		flDiarioResumido
	},

	prop: {
		cabecalho: {
			required: true,
			type: Boolean
		}
	},

	data() {
		return {
			exibir: false,
			flagFuso: $cliente.get('fuso_trecho'),
			showFuso: this.flagFuso === 'variavel' ? '(LOCAL)' : '(UTC-03:00)',
			form: {},
			bases: [],
			nomeOutroDocumento: '',
			outroDocumento: null,
			aeronaves: [],
			tripulacaoTecnica: false,
			trechoSolicitacao:'',
			fusoHorario:''
		}
	},

	mounted() {
		this._providerAeronave((lista) => (this.aeronaves = lista))
		this._providerBaseOperacional((lista) => (this.bases = lista))
	},

	created() {
		this.parametros()
		this.trechoSolicitacao = $cliente.get('componente_trecho_solicitacao')
		this.fusoHorario = $cliente.get('fuso_trecho')
	},

	methods: {
		retornaTitulo(passageiro){
			if(this.outroDocumento){
				return 'CPF/RG/'+this.nomeOutroDocumento
			} else {
				return 'CPF/RG'
			}
		},
		validaDado(dado){
			return dado == null || dado == '' || dado == '000.000.000-00' || dado == 'N/A' ? null : dado
		},
		retornaDados(passageiro){
			if(this.outroDocumento){
				
				if(this.validaDado(passageiro.cpf) && this.validaDado(passageiro.rg) && this.validaDado(passageiro.outro)){
					return this.validaDado(passageiro.cpf) + ' / ' + passageiro.rg + ' / ' + passageiro.outro
				} else if(this.validaDado(passageiro.cpf) == null && this.validaDado(passageiro.rg) && this.validaDado(passageiro.outro)){
					return 'N/A' + ' / ' + passageiro.rg + ' / ' + passageiro.outro
				} else if(this.validaDado(passageiro.cpf) && this.validaDado(passageiro.rg) == null && this.validaDado(passageiro.outro)){
					return this.validaDado(passageiro.cpf) + ' / ' + 'N/A' + ' / ' + passageiro.outro
				} else if(this.validaDado(passageiro.cpf) && this.validaDado(passageiro.rg) && this.validaDado(passageiro.outro) == null){
					return this.validaDado(passageiro.cpf) + ' / ' + passageiro.rg + ' / ' +  'N/A' 
				} else if (this.validaDado(passageiro.cpf) && this.validaDado(passageiro.rg) == null && this.validaDado(passageiro.outro) == null){
					return this.validaDado(passageiro.cpf)  + ' / ' +  'N/A' 
				} else if (this.validaDado(passageiro.cpf) == null && this.validaDado(passageiro.rg) && this.validaDado(passageiro.outro) == null){
					return 'N/A' + ' / ' + passageiro.rg  + ' / ' + 'N/A' 
				} else if (this.validaDado(passageiro.cpf) == null && this.validaDado(passageiro.rg) == null && this.validaDado(passageiro.outro)){
					return 'N/A'  + ' / ' + passageiro.outro 
				} else {
					return 'N/A'
				}
			} else {

				if(this.validaDado(passageiro.cpf) && this.validaDado(passageiro.rg)){
					return this.validaDado(passageiro.cpf) + ' / ' + passageiro.rg
				} else if(this.validaDado(passageiro.cpf) == null && this.validaDado(passageiro.rg)){
					return 'N/A' + ' / ' + passageiro.rg
				} else if(this.validaDado(passageiro.cpf) && this.validaDado(passageiro.rg) == null){
					return this.validaDado(passageiro.cpf) + ' / ' + 'N/A'
				} else {
					return 'N/A'
				}

			}
		},
		carregaDados(form) {
			this.exibir = true
			this.form = form

			if (this.form.relatorio_voo_trecho.length > 0) {
				this.$nextTick(() => {
					this.$refs.relatorioVoo.carrega(this.form.relatorio_voo_trecho)
				})
			}
		},

		parametros() {
			this._getParametro(145).then((valor) => (this.tripulacaoTecnica = valor))
			this._getParametro(3).then((valor) => (this.outroDocumento = Number(valor) == 1))
			this._getParametro(4).then((valor) => (this.nomeOutroDocumento = valor))
		},

		formatarHoras(horas) {
    	let totalSegundos = horas * 3600;	
    	let horasFormatadas = Math.floor(totalSegundos / 3600);
    	let minutosFormatados = Math.floor((totalSegundos % 3600) / 60);
    	horasFormatadas = horasFormatadas.toString().padStart(2, '0');
    	minutosFormatados = minutosFormatados.toString().padStart(2, '0');
		return `${horasFormatadas}:${minutosFormatados}`;
		}
	}
}
</script>